import { USER_ROLES } from "config/userPermissions";

export const INIT_FORM = {
    user: "",
    name: "",
    surname: "",
    category: {
        id: 0,
        name: ""
    },
    role: {
        id: 0,
        name: ""
    }
};
export const INIT_ERRORS_FORM = {
    user: false,
    name: false,
    surname: false,
    category: false,
    role: false
};
export const ERROR_TEXT_LIST = {
    INCOMPLETED_FORM: "FORMULARIO_INCOMPLETO",
    USER_NOT_EXISTS: "USUARIO_NO_EXISTE",
    USER_ALREADY_REGISTERED: "USUARIO_YA_REGISTRADO",
    NAMES_ALREADY_REGISTERED: "NOMBRES_YA_REGISTRADOS"
};
export const ERROR_TEXT_DICTIONARY = {
    "FORMULARIO_INCOMPLETO": "Para asignar un nuevo rol, debes completar todos los campos",
    "USUARIO_NO_EXISTE": "El usuario no existe, por favor prueba con otro",
    "USUARIO_YA_REGISTRADO": "El usuario ya se encuentra registrado, por favor prueba con otro usuario",
    "NOMBRES_YA_REGISTRADOS": "Dos campos coinciden con otro usuario registrado previamente, para evitar confusiones por favor modifica los campos"
};
export const USER_ROLES_NEED_CAMPUS = [
    USER_ROLES.RECURSOS_BIBLIOTECARIO,
    USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS,
    USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS
];